<template>
  <v-navigation-drawer
    fixed
    right
    temporary
    permanent
    flaoting
    width="1000"
    :class="secondaryDrawer ? 'secondary-drawer' : ''"
  >
    <v-btn title="Close" @click="cancel()" text fab small>
      <v-icon dark>$close</v-icon>
    </v-btn>
    <div class="group-listing project-listing">
      <div class="mb-12">
        <v-row class="flex-column flex-md-row">
          <v-col>
            <v-card-title
              class="display-2 letter-spacing-normal font-weight-bold mb-md-12 align-center px-5"
            >
              Contributors
            </v-card-title>
          </v-col>

          <v-col class="px-7 py-0 py-3">
            <v-row class="align-md-center">
              <v-col>
                <DatePicker
                  append-icon="$search"
                  name="check_in"
                  v-model="search.date_from"
                  label="Date from"
                  class="mb-6"
                  :is-read-only="false"
                />
              </v-col>
              <v-col>
                <DatePicker
                  v-model="search.date_to"
                  label="Date to"
                  :min="search.date_from"
                  class="mb-6"
                  :is-read-only="false"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-data-table
          :fixed-header="false"
          class="primary-table border-radius-0 v-data-table-1 data-table v-data-table-1--style2 withaction"
          :headers="headers"
          :items="data"
          :loading="model.fetching"
          loading-text="fetching data..."
          no-data-text="No data"
          no-results-text="Unable to find any data"
          :hide-default-footer="true"
        >
          <template v-slot:item.first_name="{ item }">
            {{ `${item.first_name}  ${item.last_name}` }}
          </template>
        </v-data-table>

        <v-row>
          <v-col>
            <v-card-actions class="mt-10 px-5">
              <vue-json-to-csv
                :json-data="data"
                :csv-title="csvTitle"
                v-if="data.length"
              >
                <v-btn
                  depressed
                  large
                  color="black"
                  class="white--text px-14 add-new-group"
                >
                  Export Csv
                  <v-icon class="ml-10" right>
                    $download
                  </v-icon>
                </v-btn>
              </vue-json-to-csv>
            </v-card-actions>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import PayoutRequest from '@request/PayoutRequest';
import Model from '@models/Project';
import VueJsonToCsv from 'vue-json-to-csv';
import DatePicker from '@components/utilities/DatePicker';

export default {
  name: 'Payout',
  components: {
    VueJsonToCsv,
    DatePicker,
  },
  props: {
    secondaryDrawer: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      default: () => {},
    },
    width: {
      type: [String, Number],
      default: 100,
    },
  },
  data() {
    return {
      step: this.project && this.project.id ? 2 : 1,
      request: new PayoutRequest(this.$refs, {
        project_id: this.project ? this.project.id || '' : '',
      }),
      headers: [
        {
          text: 'Name',
          sortable: false,
          value: 'first_name',
        },
        { text: 'Email', value: 'email' },
        { text: 'Contributed Date', value: 'donation_date' },
      ],
      model: new Model(),
      data: [],
      search: {},
    };
  },
  computed: {
    csvTitle() {
      let from = this.search.date_from ? `from=${this.search.date_from}` : '';
      let to = this.search.date_to ? `to=${this.search.date_to}` : '';
      return `${this.project.name.replace(
        ' ',
        '_'
      )}_contributors_${from}--${to}`;
    },
  },
  watch: {
    search: {
      handler() {
        this.syncSearch();
        this.fetchData();
      },
      deep: true,
    },
  },

  methods: {
    syncSearch() {
      this.model.date_from = this.search.date_from;
      this.model.date_to = this.search.date_to;
    },
    async fetchData() {
      let response = await this.model.getContributedUser(this.project.id);
      if (response?.data?.length) {
        this.data = response.data;
        this.data.filter(
          (data) =>
            (data.donation_date = this.$moment(data.donation_date).format(
              'Y-MM-DD'
            ))
        );
      } else {
        this.data = [];
      }
    },
    cancel() {
      this.$emit('exit');
    },
  },
  async mounted() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped></style>
